// const host = 'http://10.10.250.2:7720';
// const host_websocket = '10.10.250.2:7720';
// const host = 'http://test1.xunmengvip.com:7720';
// const host_websocket = 'test1.xunmengvip.com:7720';
const host = 'https://youxuan-api.xunmengvip.com';
const host_websocket = 'youxuan-api.xunmengvip.com';
// const host = 'https://api.xunmengvip.com/youxuan';
// const host_websocket = 'api.xunmengvip.com/youxuan';

export const COMMON_ROUTER = '';
export const IMAGE_PATH = '';

export const API_HOST = host;
export const API_HOST_WEBSOCKET = host_websocket;

export const API_IMG_UPLOAD = host + '/common/upload/image/single';
export const API_IMG_PLATE_UPLOAD = host + '/common/decoration/upload/image';

export const API_EXCEL_UPLOAD = host + '/product/main/excel/save';
export const API_HEADSHOP_EXCEL_UPLOAD = host + '/template/get/shop/excel';



// WEBPACK FOOTER //
// ./src/constants/index.js